<mat-card>
    <mat-card-content fxLayout="column">
        <div fxFlex="100" fxLayout="row" class="title">
            <title-back [addTitle]="true" [Title]="'Apply for new ops date change request'"
                (back)="back()"></title-back>
        </div>
        <span>Search by booking number to view the container details</span>

        <app-mat-auto-search [isEditable]="true" [displayField]="'request_number'" [setSearchValue]="false"
            [masterDashboard]="true" [name]="'request_number'" placeholder="Search by Request number"
            [(ngModel)]="request" (ngModelChange)="onRequestSelection($event)" [idField]="null"
            [labelItemTemplate]="requestSelectedItem" [itemTemplate]="requestItem"
            [listUrl]="request_url+'?search=::search::'">
        </app-mat-auto-search>

        <img alt="" class="opsDateChangeBgImage" src="assets/images/backgrounds/ops-date-change.png">
    </mat-card-content>

</mat-card>


<ng-template #requestItem let-item let-index>
    <div fxFlex="100" fxLayout="column" class="requestListShow">
        <span class="requestNumber fs-13">
            {{ item?.request_number }}
            ({{ item?.request_type?.name }} | {{
            item?.request_type?.dev_name == 'buy_sell' ? item?.transaction_type ==
            'use'
            ? 'Buy' : 'Sell' : item?.transaction_type == 'use' ? 'Use' : 'Supply'
            }} {{ item?.requirement[0]?.quantity }}*{{ item?.requirement[0]?.container_size_type?.display }})
            <ng-container *ngIf="item?.requirement.length>1">+ {{ item?.requirement.length - 1 }} More</ng-container>
        </span>
        <span class="companyName">
            {{ item?.requirement[0]?.quantity }}*{{ item?.requirement[0]?.container_size_type?.display }}
            ({{ item?.requirement[0]?.condition?.value }})<br>
            <span>{{ item?.transaction_type == 'use' ? 'Customer' : 'Supplier' }}</span>:
            {{ item?.company ?? '-' }}
        </span>
    </div>
</ng-template>

<ng-template #requestSelectedItem let-item>
    {{ item?.request_number }}
</ng-template>